import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

export default function singleEventsComponent() {
  const galleryBlocks = document.querySelectorAll('.training-and-events-single .news-content-gallery-block');
  galleryBlocks.forEach((block) => {
    const el = block.querySelector('.gallery-swiper');
    if (!el || el.swiper) return;
    const wrapper = el.closest('.gallery-wrapper') || el.parentElement;
    const prevEl = wrapper?.querySelector('[data-js="gallery-prev"]');
    const nextEl = wrapper?.querySelector('[data-js="gallery-next"]');
    const slideCount = el.querySelectorAll('.swiper-slide').length;
    const hasMultipleSlides = slideCount > 1;

    block.classList.toggle('is-single-slide', !hasMultipleSlides);

    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: hasMultipleSlides ? 2 : 1,
      spaceBetween: hasMultipleSlides ? 30 : 0,
      loop: hasMultipleSlides,
      speed: 400,
      watchOverflow: true,
      allowTouchMove: hasMultipleSlides,
      navigation: {
        prevEl: hasMultipleSlides ? prevEl : null,
        nextEl: hasMultipleSlides ? nextEl : null,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: hasMultipleSlides ? 16 : 0,
        },
        768: {
          slidesPerView: hasMultipleSlides ? 2 : 1,
          spaceBetween: hasMultipleSlides ? 24 : 0,
        },
      },
    });
  });

  const speakersEls = document.querySelectorAll('[data-js="event-speakers-swiper"]');
  speakersEls.forEach((el) => {
    if (el.swiper) return;
    const section = el.closest('.speakers-section') || el.parentElement;
    const prevEl = section?.querySelector('[data-js="event-speakers-prev"]');
    const nextEl = section?.querySelector('[data-js="event-speakers-next"]');
    const paginationEl = section?.querySelector('[data-js="event-speakers-pagination"]');
    const panels = section ? Array.from(section.querySelectorAll('[data-js="event-speaker-panel"]')) : [];
    const slideCount = el.querySelectorAll('.swiper-slide').length;
    const hasManySlides = slideCount > 1;

    const syncPanel = (index) => {
      if (!panels.length) return;
      panels.forEach((panel) => {
        const panelIndex = Number(panel.dataset.speakerIndex || 0);
        panel.classList.toggle('is-active', panelIndex === index);
      });
    };

    const swiper = new Swiper(el, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: hasManySlides,
      speed: 450,
      watchOverflow: true,
      allowTouchMove: hasManySlides,
      autoplay: hasManySlides
        ? {
            delay: 15000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            enabled: false,
          }
        : false,
      navigation: {
        prevEl: hasManySlides ? prevEl : null,
        nextEl: hasManySlides ? nextEl : null,
      },
      pagination: {
        el: hasManySlides ? paginationEl : null,
        clickable: true,
        bulletClass: 'odl-bullet',
        bulletActiveClass: 'is-active',
        renderBullet: (index, className) => `<span class="${className}" aria-label="Speaker ${index + 1}"></span>`,
      },
      on: {
        init(sw) {
          syncPanel(sw.realIndex || 0);
        },
        slideChange(sw) {
          syncPanel(sw.realIndex || 0);
        },
      },
    });

    if (hasManySlides && section) {
      const viewportObserver = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            swiper.autoplay?.start();
          } else {
            swiper.autoplay?.stop();
          }
        },
        { threshold: 0.25 },
      );
      viewportObserver.observe(section);
    }

    syncPanel(swiper.realIndex || 0);
  });

  const testimonialEls = document.querySelectorAll('.training-and-events-single [data-js="testimonial-swiper"]');
  testimonialEls.forEach((el) => {
    if (el.swiper) return;
    const wrapper = el.closest('.testimonials') || el.parentElement;
    const prevEl = wrapper?.querySelector('[data-js="testimonial-prev"]');
    const nextEl = wrapper?.querySelector('[data-js="testimonial-next"]');
    const slideCount = el.querySelectorAll('.swiper-slide').length;
    const hasManySlides = slideCount > 1;

    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 24,
      loop: hasManySlides,
      speed: 400,
      autoHeight: true,
      navigation: {
        prevEl: hasManySlides ? prevEl : null,
        nextEl: hasManySlides ? nextEl : null,
      },
    });
  });
}
